import { render, staticRenderFns } from "./AddOption.vue?vue&type=template&id=6cbe81ee&scoped=true"
import script from "./AddOption.vue?vue&type=script&lang=js"
export * from "./AddOption.vue?vue&type=script&lang=js"
import style0 from "./AddOption.vue?vue&type=style&index=0&id=6cbe81ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe81ee",
  null
  
)

export default component.exports